import PriceMatrixRow from "./PriceMatrixRow";

export default PriceMatrixRow;
